import Note from "../small-components/Note";
const NotesList = ({ flowerData }) => {
  return (
    <div>
      <Note flowerData={flowerData} />
    </div>
  );
};

export default NotesList;
